<div class="page-content">

      <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

      <h1 class="page_title" translate>{{'next_registration.page_title'}}</h1>

      <ng-radio [(ng-model)]="aboutChild.isNextChild"  margin="/1.5" id="isNextChildRadio"
                [(ng-error)]="error_nextChild" (change)="onNextChild()"
                [item-list]="items.yesNoList">
                   <h2 id="isNextChild" translate>{{'next_registration.likeToRegister'}}</h2>
      </ng-radio>

      <div [hidden]="aboutChild.isNextChild!=YES">

      <ng-radio [(ng-model)]="aboutChild.isSameBirthday"  margin="/1.5" id="sameBirthdayRadio"
                  [(ng-error)]="error_sameBirthday"
                  [item-list]="items.yesNoList">
            <h2 id="sameBirthday" translate='next_registration.sameBirthday' [translateParams]="childParam"></h2>
      </ng-radio>

      <birth-day style="margin-bottom:1.5em" [(ng-model)]="aboutChild.nextBirthDay" nextRegistration='Y' [hidden]="aboutChild.isSameBirthday!=NO"></birth-day>

      <ng-radio [(ng-model)]="aboutChild.isSameAddress"   margin="/1.5" id="sameAddressRadio"
                  [(ng-error)]="error_sameAddress"
                  [item-list]="items.yesNoList">
            <h2 id="sameAddress" translate>{{'next_registration.sameAddress'}}</h2>
      </ng-radio>

      <child-deceased [(ng-model)]="aboutChild.nextChildDeceased" still-birth='N'></child-deceased>

      </div>

      <div style="display:flex; justify-content:center">
            <div *ngIf="data.subject.siteKey">
                  <div [hidden]="aboutChild.isNextChild!='N' || data.orderOfBC.total > 0 || data.isSubmit">
                        <re-captcha (resolved)="resolved($event)"  siteKey="{{data.subject.siteKey}}"> </re-captcha>     
                  </div>
            </div>
            
            <div class="wait-icon" [hidden]="!data.isSubmit" >
              <img src="refresh/assets/images/ChasingArrows.gif">
            </div>      
       </div>
  

      <div class="btn-div">

          <div>
                <button class="btn-next" id="btn-next" alt-text="next_registration.continue_alt1"
                        [class.btn-disabled]="disabled&&aboutChild.isNextChild=='N'&&data.orderOfBC.total==0" 
                        [hidden]="data.isSubmit" (click)="onNextClick()" translate>{{Button.Next}}
                </button>
          </div>
      </div>

</div>
